import { ELEMENT_MENTION } from '@aline/common';
import { createSlatePlugin } from 'platejs';

/**
 * Framework-agnostic definition of the inline-void `mention` node. Registered in every
 * AlineMarkdownEditor so mention elements produced by deserializeMarkdownWithMentions
 * normalize correctly, and reused directly by the markdown round-trip tests (which run
 * without React). The chip render component is attached in user-mention-kit.
 */
export const BaseMentionElementPlugin = createSlatePlugin({
  key: ELEMENT_MENTION,
  node: {
    isElement: true,
    isInline: true,
    isMarkableVoid: true,
    isVoid: true,
  },
});
